<template>
  <div>
    <Head :title="form.course.name" />
    <div class="mb-8 flex max-w-3xl justify-start">
      <h1 class="text-3xl font-bold">
        <Link
          class="text-indigo-500 hover:text-indigo-600"
          :href="$routes.courses()"
        >
          Cursuri
        </Link>
        <span class="font-medium text-indigo-400">/</span>
        {{ form.course.name }}
      </h1>
    </div>
    <div class="max-w-3xl overflow-hidden rounded-sm bg-white shadow-sm">
      <course-form v-model="form" @submit="submit">
        <div
          class="flex items-center border-t border-gray-200 bg-gray-100 px-8 py-4"
        >
          <button
            v-if="!course.deleted_at"
            class="text-red-800 hover:underline"
            tabindex="-1"
            type="button"
            @click="destroy"
          >
            Sterge cursul
          </button>
          <loading-button
            :loading="form.processing"
            class="btn-teal ml-auto"
            type="submit"
          >
            Updateaza cursul
          </loading-button>
        </div>
      </course-form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3';
import Layout from '@/Layouts/Main.vue';
import LoadingButton from '@/Shared/LoadingButton.vue';
import CourseForm from './Form.vue';

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    CourseForm,
  },
  layout: Layout,
  props: {
    course: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: this.$inertia.form({
        course: {
          ...this.course,
        },
      }),
      modalNewChapter: false,
      selectedChapter: null,
      fileForm: this.$inertia.form({
        file: null,
      }),
    };
  },

  methods: {
    // TODO: Understand below
    submit() {
      this.form.put(this.$routes.course(this.course.id), {
        onSuccess: () => this.form.reset('password', 'photo'),
      });
    },
    uploadPhoto() {
      this.fileForm.post(
        this.$routes.add_file_chapter(this.selectedChapter.id),
        {
          onSuccess: () => this.fileForm.reset('file'),
        },
      );
    },
    destroy() {
      if (confirm('Are you sure you want to delete this course?')) {
        this.$inertia.delete(this.$routes.course(this.course.id));
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this course?')) {
        this.$inertia.put(this.$routes.restore_course(this.course.id));
      }
    },
  },
};
</script>
